export enum EventHandlers {
  loaded = 'loaded',
  rendered = 'rendered',
  error = 'error',
  visualClicked = 'visualClicked',
  pageChanged = 'pageChanged',
}
